import React, { useReducer, useState } from "react"
import { Form, Button } from "react-bootstrap"
import Alerts from "../Alerts"
import ShelterBanner from "../Admin/ShelterBanner"
import * as styles from "./Styles/Settings.module.scss"
import "../../styles/layouts.scss"
import "../../styles/full_height.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

export default (props) => {
  const [mail, setMail] = useState(props.email)
  const [passwords, dispatchPasswords] = useReducer(passwordReducer, {
    password: "",
    password_confirmation: "",
  })
  const [showBannerModal, setShowBannerModal] = useState(false)

  function passwordReducer(before, action) {
    switch (action.type) {
      case "password":
        return { ...before, password: action.value }
      case "passwordConfirmation":
        return { ...before, password_confirmation: action.value }
      default:
        return before
    }
  }

  return (
    <React.Fragment>
      <Alerts error={props.error} notice={props.notice} />
      <div className={cn("l-centering", "l-flex--column", "background")}>
        <div className={styles.form}>
          <Form action={props.path} method="POST" className={styles.formInner}>
            <Form.Group controlId="signInForm.email">
              <Form.Label>メールアドレス</Form.Label>
              <Form.Control
                type="email"
                placeholder="name@example.com"
                name="email"
                value={mail}
                onChange={(e) => setMail(e.target.value)}
              />
            </Form.Group>
            <input type="hidden" name="_method" value="PATCH" />
            <input
              type="hidden"
              name="authenticity_token"
              value={props.token}
            />
            <Button type="submit" className="l-primary-button--admin">
              変更する
            </Button>
          </Form>
          <hr className="common-hr" />
          <div className={styles.verified}>
            <div className={styles.notice}>
              メールアドレス{props.verified ? "認証済み" : "未認証"}
            </div>
            {!props.verified && (
              <Form action="/tokens" method="POST">
                <input
                  type="hidden"
                  name="authenticity_token"
                  value={props.token}
                />
                <Button type="submit" className="l-primary-button--admin">
                  認証メールを再送する
                </Button>
              </Form>
            )}
          </div>
        </div>

        <Form action={props.path} method="POST" className={styles.form}>
          <Form.Group controlId="signInForm.password">
            <Form.Label>パスワード</Form.Label>
            <Form.Control
              type="password"
              placeholder="半角英数字記号 10文字以上"
              name="password"
              autoComplete="new-password"
              value={passwords.password}
              onChange={(e) =>
                dispatchPasswords({ type: "password", value: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group controlId="signInForm.passwordConfirm">
            <Form.Label>パスワード（確認）</Form.Label>
            <Form.Control
              type="password"
              placeholder="パスワード再入力"
              name="password_confirmation"
              autoComplete="new-password"
              value={passwords.password_confirmation}
              onChange={(e) =>
                dispatchPasswords({
                  type: "passwordConfirmation",
                  value: e.target.value,
                })
              }
            />
          </Form.Group>
          <input type="hidden" name="_method" value="PATCH" />
          <input type="hidden" name="authenticity_token" value={props.token} />
          <Button type="submit" className="l-primary-button--admin">
            変更する
          </Button>
        </Form>
        {props.editablePlaces.length > 0 && (
          <div className={styles.form}>
            <a href="/admin/places" target="_blank">
              編集可能な施設一覧
            </a>
          </div>
        )}
        {props.showShelterBanners && (
          <div className={styles.form}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault()
                setShowBannerModal(true)
              }}
            >
              防災ランプリンク用バナー画像DL
            </a>
            <ShelterBanner
              show={showBannerModal}
              onClose={() => {
                setShowBannerModal(false)
              }}
            />
          </div>
        )}
        <div className={styles.form}>
          <a href="/sign_out">ログアウト</a>
        </div>
      </div>
    </React.Fragment>
  )
}
